/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import clsx from 'clsx';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';

import {
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Button,
} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { isMobileSafari, isIOS } from 'react-device-detect';

import Link from '@material-ui/core/Link';
import Header from '../../components/Header';
import Create from './Create';

import useStyles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Adresses() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [notCurrentLocation, setNotCurrentLocation] = useState(false);

  const { modalAdresses, modalCreateAddress, adresses } = useSelector(
    state => state.adresses
  );

  const orderAddress = useSelector(state => {
    const { order } = state.order;
    return order ? order.address : null;
  });

  useEffect(() => {
    if (modalAdresses) dispatch({ type: '@adresses/MODAL' });
  }, [orderAddress]);

  function handleClose() {
    dispatch({ type: '@adresses/MODAL' });
  }

  function handleCloseWarning() {
    setNotCurrentLocation(!notCurrentLocation);
  }

  function handleCreate() {
    if (isIOS || isMobileSafari) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        dispatch({
          type: '@adresses/CURRENT_LOCATION',
          currentLocation: {
            lat: crd.latitude,
            lng: crd.longitude,
          },
        });
        dispatch({ type: '@adresses/CREATE' });
      }

      function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        setNotCurrentLocation(true);
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    } else {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        navigator.geolocation.getCurrentPosition(position => {
          const currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          dispatch({ type: '@adresses/CURRENT_LOCATION', currentLocation });
          dispatch({ type: '@adresses/CREATE' });
        });
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition(position => {
            const currentLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            dispatch({ type: '@adresses/CURRENT_LOCATION', currentLocation });
            dispatch({ type: '@adresses/CREATE' });
          });
        } else if (result.state === 'denied') {
          setNotCurrentLocation(true);
        }
        result.onchange = () => {
          if (result.state === 'granted') {
            navigator.geolocation.getCurrentPosition(position => {
              const currentLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              dispatch({ type: '@adresses/CURRENT_LOCATION', currentLocation });
              dispatch({ type: '@adresses/CREATE' });
            });
          } else if (result.state === 'denied') {
            setNotCurrentLocation(true);
          }
        };
      });
    }
  }
  function handleAddress(address) {
    dispatch({ type: '@order/SET_ADDRESS', address });
  }

  return (
    <>
      <Dialog fullScreen={fullScreen} maxWidth="xs" open={modalAdresses}>
        <Header handleClose={handleClose} title="meus endereços" />

        <div className={classes.create} onClick={handleCreate}>
          <span>Adicionar</span>
        </div>

        <Box style={{ background: '#eee', padding: 10 }}>
          {adresses
            .filter(f => f.neighborhood !== 'RETIRAR')
            .map(address => (
              <Box
                key={address.address_id}
                onClick={() => handleAddress(address)}
                className={clsx(classes.address, {
                  [classes.invalid]: !address.validated,
                })}
              >
                <LocationOnOutlinedIcon />
                <Box className={classes.body}>
                  <Box className={classes.title}>
                    <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                      {`${address.name}`}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography style={{ fontSize: 13 }}>
                      {` ${address.zip_code}`}
                      {` ${address.public_place}`}
                      {` ${address.number},`}
                      {` ${address.state}`}
                      {` ${address.city}`}
                      {` ${address.neighborhood}`}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
        </Box>
      </Dialog>
      {notCurrentLocation === true ? (
        <Dialog
          open={notCurrentLocation}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseWarning}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle
            id="alert-dialog-slide-title"
            style={{ textAlign: 'center' }}
          >
            Não temos acesso à sua localização
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-slide-description"
              style={{ textAlign: 'center' }}
            >
              Você pode mudar o acesso à sua localização nas configurações de
              "Local" do seu navegador. Para facilitar, criamos um{' '}
              <Link
                href="https://www.notion.so/Tutorial-para-libera-o-de-acesso-localiza-o-bca4e2ca7a0d4777b8868f8358bc9c1b"
                target="_blank"
              >
                tutorial
              </Link>{' '}
              para que você possa autorizar sua localização novamente
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              className={classes.buttonConfirm}
              variant="contained"
              color="primary"
              onClick={handleCloseWarning}
            >
              Concordo
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      {modalCreateAddress === true ? <Create /> : null}
    </>
  );
}
